import { TextField, Typography } from '@arionbanki/arionui';
import { Footer, ProgressBar } from 'components';
import { useParents } from './useParents';

export function Parents() {
	const { data, entityType, flowType, formErrors, goBack, submitForm, t } = useParents();
	return (
		<ProgressBar page="parents">
			<div className="w-100 mb-4">
				<Typography TagName="h3" className="mb-5">
					{t('parents')}
				</Typography>
				<p>{t(`${flowType}_${entityType}_description`)}</p>
				<form className="mb-5 mt-5">
					{Array.isArray(data) && data[0] && (
						<div className="row mb-5">
							<div className="col-12">
								<p>{data[0].name}</p>
							</div>
							<div className="col-sm-12 col-md-6">
								<TextField defaultValue={data[0].phoneNumber} disabled label={t('phone')} name="" />
							</div>
							<div className="col-sm-12 col-md-6">
								<TextField defaultValue={data[0].email} disabled label={t('email')} name="" />
							</div>
						</div>
					)}
					{Array.isArray(data) && data[1] && (
						<div className="row mb-sm-4">
							<div className="col-12">
								<p>{data[1].name}</p>
							</div>
							<div className="col-sm-12 col-md-6">
								<TextField
									defaultValue={data[1].phoneNumber}
									error={formErrors?.phone}
									label={t('phone')}
									name="phone"
								/>
							</div>
							<div className="col-sm-12 col-md-6">
								<TextField defaultValue={data[1].email} error={formErrors?.email} label={t('email')} name="email" />
							</div>
						</div>
					)}
				</form>
				<Footer handleNext={submitForm} handlePrev={goBack} isDisabled={false} next={t('continue')} prev={t('back')} />
			</div>
		</ProgressBar>
	);
}
